import {
    GET_USERS,
    GET_USERS_SUCCESS,
    GET_USERS_SUCCESS_FAILED
} from './actionTypes';


const initialState = {
    error: "",
    loading: false,
    users: undefined,
    total: undefined
}

const allUsers = (state = initialState, action) => {
    switch (action.type) {
        case GET_USERS:
            state = {
                ...state,
                loading: true
            }
            break;
        case GET_USERS_SUCCESS:
            console.log("payload ===", action.payload);
            state = {
                ...state,
                loading: false,
                total: action.payload.total,
                users: JSON.parse(action.payload.users)
            }
            break;
        case GET_USERS_SUCCESS_FAILED:
            state = {
                ...state,
                loading: false
            };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default allUsers;